import { Box, Button } from '@mui/material';

type MobileDialogFooterProps = {
  handleOpenCloseDialog: () => void;
  buttonText?: string;
};

export const MobileDialogFooter = ({
  handleOpenCloseDialog,
  buttonText = 'APPLY',
}: MobileDialogFooterProps) => (
  <Box
    sx={{
      position: 'fixed',
      left: 0,
      right: 0,
      bottom: 0,
      p: 3,
      bgcolor: 'white',
    }}
  >
    <Button fullWidth onClick={handleOpenCloseDialog}>
      {buttonText}
    </Button>
  </Box>
);
